<template>
  <div class="catalog-programmirovanie">
    <section>
      <programmirovanie-modal
        v-if="modalState"
        :card="modalCard"
        @close="closeModal"
      />

      <programmirovanie-banner
        @open-modal="openModal"
      />
    </section>

    <programmirovanie-catalog
      @open-modal="openModal"
      @direction="directionFilter = $event"
      @format="formatFilter = $event"
    />

    <programmirovanie-study />

    <programmirovanie-why />

    <programmirovanie-reviews />

    <programmirovanie-form />

    <faq-accordion-new
      page="programmirovanie"
      sticker-url="/v2/catalog/programmirovanie/sticker.png"
    />

    <programmirovanie-seo />
  </div>
</template>

<script>
import HeadMixin from '~/mixins/HeadMixin';
import { directionsList, FORMATS } from '~/components/v2/catalog/programmirovanie/catalog/programmirovanieCards';

import FaqAccordionNew from '~/components/v2/common/FaqAccordion/FaqAccordionNew.vue';
import ProgrammirovanieSeo from '~/components/v2/catalog/programmirovanie/ProgrammirovanieSeo.vue';
import ProgrammirovanieForm from '~/components/v2/catalog/programmirovanie/ProgrammirovanieForm.vue';
import ProgrammirovanieBanner from '~/components/v2/catalog/programmirovanie/ProgrammirovanieBanner.vue';
import ProgrammirovanieModal from '~/components/v2/catalog/programmirovanie/ProgrammirovanieModal.vue';
import ProgrammirovanieCatalog from '~/components/v2/catalog/programmirovanie/catalog/ProgrammirovanieCatalog.vue';
import ProgrammirovanieReviews from '~/components/v2/catalog/programmirovanie/ProgrammirovanieReviews.vue';
import ProgrammirovanieWhy from '~/components/v2/catalog/programmirovanie/ProgrammirovanieWhy.vue';
import ProgrammirovanieStudy from '~/components/v2/catalog/programmirovanie/ProgrammirovanieStudy.vue';

export default {
  name: 'CatalogProgrammirovanieDlyaDetej',
  components: {
    ProgrammirovanieStudy,
    ProgrammirovanieWhy,
    ProgrammirovanieReviews,
    ProgrammirovanieCatalog,
    ProgrammirovanieModal,
    ProgrammirovanieBanner,
    ProgrammirovanieSeo,
    ProgrammirovanieForm,
    FaqAccordionNew,
  },
  mixins: [HeadMixin],
  layout: 'DefaultLayoutV2',
  scrollToTop: false,
  data: () => ({
    modalState: false,
    modalCard: null,

    directionFilter: null,
    formatFilter: null,

    // для head
    image: '/v2/catalog/programmirovanie/share-image.jpg',
  }),

  computed: {
    // для head
    /* eslint-disable max-len,vue/max-len */
    title() {
      if (!this.directionFilter && this.formatFilter) {
        if (this.formatFilter === FORMATS.beginner) return 'Программирование для детей с нуля от онлайн-школы «Синергия»';
        if (this.formatFilter === FORMATS.advanced) return 'Продвинутое программирование для детей от онлайн-школы «Синергия»';
        if (this.formatFilter === FORMATS.tutor) return 'Программирование для детей с репетитором от онлайн-школы «Синергия»';
      }

      const direction = directionsList.find(({ id }) => id === this.directionFilter);
      if (this.directionFilter && !this.formatFilter) {
        return `Программирование для детей ${direction.pretext} ${direction.title} от онлайн-школы «Синергия»`;
      }

      if (this.directionFilter && this.formatFilter === FORMATS.beginner) {
        return `Программирование для детей: ${direction.title} с нуля в онлайн-школе «Синергия»`;
      }
      if (this.directionFilter && this.formatFilter === FORMATS.advanced) {
        return `Продвинутое программирование для детей ${direction.pretext} ${direction.title} | онлайн-школа «Синергия»`;
      }
      if (this.directionFilter && this.formatFilter === FORMATS.tutor) {
        return `Обучение программированию ${direction.pretext} ${direction.title} детей с репетитором`;
      }

      return 'Программирование для детей: с нуля до профи в онлайн-школе Синергия';
    },
    description() {
      if (!this.directionFilter && this.formatFilter) {
        const text = this.formatFilter === FORMATS.tutor ? 'репетиторы' : 'курсы';
        return `Откройте для ребенка мир программирования: ${text} для детей по Scratch, Python, JavaScript, Java, Minecraft, Roblox, C++, CoSpaces и другим языкам`;
      }

      const direction = directionsList.find(({ id }) => id === this.directionFilter);
      if (this.directionFilter && !this.formatFilter) {
        return `Обучение программированию ${direction.pretext} ${direction.title} для детей в онлайн-школе Синергия. Узнайте больше о курсах и запишитесь!`;
      }

      if (this.directionFilter && this.formatFilter === FORMATS.beginner) {
        return `Заинтересуйте ребенка программированием! Онлайн-школа Синергия предлагает курсы ${direction.title} для детей, разработанные опытными педагогами`;
      }
      if (this.directionFilter && this.formatFilter === FORMATS.advanced) {
        return `Детский курс ${direction.title}: онлайн-школа «Синергия» обучает юных программистов. Узнайте больше и запишитесь на бесплатный пробный урок!`;
      }
      if (this.directionFilter && this.formatFilter === FORMATS.tutor) {
        return `Подарите ребенку интересную профессию будущего! Курсы ${direction.title} для детей с репетитором в онлайн-школе «Синергия»`;
      }
      return 'Обучаем программированию детей и подростков от 8 до 18 лет. IT-курсы, уроки, репетиторы – все для юных программистов';
    },
    /* eslint-enable */
  },

  mounted() {
    // чтобы работал sticky
    document.querySelector('.v2-layout').style.overflow = 'inherit';
  },
  methods: {
    closeModal() {
      this.modalState = false;
    },
    openModal(card = null) {
      this.modalCard = card;
      this.modalState = true;
    },
  },
};
</script>

<style scoped lang="scss">

.catalog-programmirovanie {
  background-color: $gray-bg;

  padding-top: 80px;
  padding-bottom: 100px;
  display: flex;
  flex-direction: column;
  gap: 200px;

  @include media-down(laptop) {
    gap: 150px;
  }

  @include media-down(tablet) {
    padding-top: 64px;
    gap: 120px;
  }

  @include media-down(mobile) {
    gap: 96px;
  }

  :deep(.programmirovanie-catalog) {
    @include media-up(laptop) {
      margin-top: -80px;
    }
  }

  :deep(.programmirovanie__filters-mob) {
    margin-top: -12px;
  }

  ::v-deep .faq {
    overflow: hidden;

    &__sticker {
      z-index: 2;
      top: 120px;
      right: -25px;

      @include media-down(tablet) {
        width: 40px;
        top: 125px;
        right: -3px;
      }
    }
  }
}

</style>
